<template>
  <div class="page flex-col">
    <div class="block_1 flex-col justify-end">
      <div class="box_1 flex-row items-center"> <!-- 新增items-center确保垂直居中 -->
        <img class="image_1" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5eb7835fc957042f4b02048930b15033b02aadc08574d830df2c060761b9879a.png" />
        <img class="image_2" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b858c76b9deb5b3941827f27d1c8ac1b586ba98eec1392060201b04c690af4c.png" />
        <span class="text_1">自由随心·Al随行·慧安智远</span>
        <span class="text_2">首页</span>
        <!-- <span class="text_3" @click="sdycxq">产品方案</span> -->

        <div class="dropdown-container" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <span class="text_4 cursor-pointer">产品方案</span>
          <div class="dropdown-menu" v-if="showDropdown">
            <div class="dropdown-item" @click="handleCaseClick('three_narcotic_drug_vehicle')">三代麻精药品车</div>
            <div class="dropdown-item" @click="handleCaseClick('two_narcotic_drug_vehicle')">二代麻精药品车</div>
            <div class="dropdown-item" @click="handleCaseClick('consumables_cabinet')">高值耗材柜</div>
            <div class="dropdown-item" @click="handleCaseClick('ai_recycling_bin')">AI智能回收箱</div>
            <div class="dropdown-item" @click="handleCaseClick('hydrogenperoxide_disinfection_machine')">过氧化氢消毒机</div>
            <div class="dropdown-item" @click="handleCaseClick('transfer_bed')">电动转运床</div>

          </div>
        </div>

        <span class="text_4" @click="case_presentation">案例展示</span>



        <span class="text_5" @click="news_information">新闻动态</span>
        <span class="text_6" @click="guanyuhuian">关于慧安</span>
      </div>

      <div class="box_2 flex-row">
        <div class="group_1 flex-col"></div>
      </div>
    </div>
     <div class="block_2 flex-col">
    <!-- 视频背景 -->
    <video 
      class="bg-video" 
      autoplay 
      muted 
      loop 
      playsinline
      src="./assets/img/sysp.mp4"
    >
    </video>
    
    <!-- 这里是原有内容 -->
  </div>
    <div class="block_3 flex-col">
      <span class="text_7">我们的核心产品方案</span>
      <div class="section_1 flex-row justify-between">
        <div class="image-wrapper_1 flex-col">
          <img class="image_3" referrerpolicy="no-referrer" src="./assets/img/sy.png" />
        </div>
        <div class="block_4 flex-col">
          <div class="text-wrapper_1 flex-col"><span class="text_8">产品1</span></div>
          <span class="text_9">第三代麻精药品车</span>
          <span class="text_10">
            和尔思第三代麻精药品车较二代升级：容量增30%，新增温湿度等数显及置物盒，单支单仓存储，冷藏抽屉可称重，实现单支管控。
          </span>
          <div class="image-text_1 flex-row justify-between">
            <img class="thumbnail_1" referrerpolicy="no-referrer"
              src="./assets/img/SketchPngc31f19d4224a876bcb1edf257cf908bb1fcec21283873fed05109d3fb0c63d02.png" />
            <span class="text-group_1">绝对效期管理</span>
          </div>
          <div class="image-text_2 flex-row justify-between">
            <img class="thumbnail_2" referrerpolicy="no-referrer"
              src="./assets/img/SketchPngc31f19d4224a876bcb1edf257cf908bb1fcec21283873fed05109d3fb0c63d02.png" />
            <span class="text-group_2">高级别单支管控</span>
          </div>
          <div class="image-text_3 flex-row justify-between">
            <img class="thumbnail_3" referrerpolicy="no-referrer"
              src="./assets/img/SketchPngc31f19d4224a876bcb1edf257cf908bb1fcec21283873fed05109d3fb0c63d02.png" />
            <span class="text-group_3">分区冷藏，自动计数</span>
          </div>
          <div class="text-wrapper_2 flex-col" @click="sdycxq"><span class="text_11">查看详情</span></div>
        </div>
      </div>
      <div class="section_2 flex-row justify-between">
        <div class="block_5 flex-col">
          <div class="text-wrapper_3 flex-col"><span class="text_12">产品2</span></div>
          <span class="text_13">高值耗材柜</span>
          <span class="text_14">
            和尔思高值耗材柜用RFID技术，两步存取秒响应，存各类耗材，接HIS系统，支持多种登录，自动盘点组网，提升管理效率。
          </span>
          <div class="image-text_4 flex-row justify-between">
            <img class="thumbnail_4" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng140eae03dc15a84c7d53b6c12e31fbb97f3b0b1632b0e81f196ed17c69f16032.png" />
            <span class="text-group_4">RFID射频技术</span>
          </div>
          <div class="image-text_5 flex-row justify-between">
            <img class="thumbnail_5" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng140eae03dc15a84c7d53b6c12e31fbb97f3b0b1632b0e81f196ed17c69f16032.png" />
            <span class="text-group_5">超大空间存储</span>
          </div>
          <div class="image-text_6 flex-row justify-between">
            <img class="thumbnail_6" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng140eae03dc15a84c7d53b6c12e31fbb97f3b0b1632b0e81f196ed17c69f16032.png" />
            <span class="text-group_6">可扩展性强</span>
          </div>
          <div class="text-wrapper_4 flex-col" @click="gzhcgxq"><span class="text_15">查看详情</span></div>
        </div>
        <div class="image-wrapper_2 flex-col">
          <img class="image_4" referrerpolicy="no-referrer" src="./assets/img/sy2.png" />
        </div>
      </div>
      <div class="section_3 flex-row justify-between">
        <div class="image-wrapper_3 flex-col">
          <img class="image_5" referrerpolicy="no-referrer" src="./assets/img/sy3.png" />
        </div>
        <div class="group_2 flex-col">
          <div class="text-wrapper_5 flex-col"><span class="text_16">产品3</span></div>
          <span class="text_17">AI智能回收箱</span>
          <span class="text_18">
            AI智能安瓿回收箱针对传统人工回收效率低等问题，以AI引擎视觉比对空瓶与取药信息，全流程自动化，拍照留存便于回溯，解决监管难等问题，实现高效归还。
          </span>
          <div class="image-text_7 flex-row justify-between">
            <img class="thumbnail_7" referrerpolicy="no-referrer"
              src="./assets/img/SketchPngc31f19d4224a876bcb1edf257cf908bb1fcec21283873fed05109d3fb0c63d02.png" />
            <span class="text-group_7">智能AI识别</span>
          </div>
          <div class="image-text_8 flex-row justify-between">
            <img class="thumbnail_8" referrerpolicy="no-referrer"
              src="./assets/img/SketchPngc31f19d4224a876bcb1edf257cf908bb1fcec21283873fed05109d3fb0c63d02.png" />
            <span class="text-group_8">一次性多瓶识别</span>
          </div>
          <div class="image-text_9 flex-row justify-between">
            <img class="thumbnail_9" referrerpolicy="no-referrer"
              src="./assets/img/SketchPngc31f19d4224a876bcb1edf257cf908bb1fcec21283873fed05109d3fb0c63d02.png" />
            <span class="text-group_9">99%识别准确率</span>
          </div>
          <div class="text-wrapper_6 flex-col" @click="aihsxq"><span class="text_19">查看详情</span></div>
        </div>
      </div>
      <div class="list_1 flex-row">
        <div class="list-items_1 flex-col" v-for="(item, index) in loopData0" :key="index">
          <div v-if="item.slot3 === 3" class="group_3 flex-row">
            <div class="text-wrapper_7 flex-col"><span class="text_20">自动消杀</span></div>
            <div class="text-wrapper_8 flex-col"><span class="text_21">智能记录</span></div>
          </div>
          <div v-if="item.slot1 === 1" class="group_4 flex-col">
            <!-- <img class="image_6" referrerpolicy="no-referrer"
              src="./assets/img/SketchPngafcdd83eca82596441cbc04f949fc75c84b294924b7f7dd1e8307f82f9baaab9.png" /> -->
            <div class="text-wrapper_9 flex-col"><span class="text_22">灵活存储</span></div>
            <div class="text-wrapper_10 flex-col"><span class="text_23">小巧便捷</span></div>
          </div>
          <div v-if="item.slot2 === 2" class="group_5 flex-col">
            <div class="block_6 flex-col">
              <div class="text-wrapper_11 flex-col"><span class="text_24">电动助力</span></div>
            </div>
            <div class="text-wrapper_12 flex-col"><span class="text_25">全自动转运调控</span></div>
          </div>
          <div class="text-group_10 flex-col justify-between">
            <span class="text_26" v-html="item.lanhutext0"></span>
            <span class="text_27" v-html="item.lanhutext1"></span>
          </div>
          <div class="text-wrapper_13 flex-col" @click="sbxq(item)"><span class="text_28"
              v-html="item.lanhutext2"></span></div>
        </div>
      </div>
    </div>
    <div class="block_7 flex-col" @click="xwdt">
      <span class="text_29">新闻动态</span>
      <div class="box_3 flex-row">
        <div class="text-group_11 flex-col justify-between">
          <span class="text_30">6.20</span>
          <span class="text_31">2025</span>
        </div>
        <div class="image-text_10 flex-col justify-between">
          <div class="group_6 flex-col"></div>
          <div class="text-group_12 flex-col justify-between">
            <span class="text_32">2025年湖州嘉兴麻醉学学术年会暨临床麻醉质控年会</span>
            <span class="text_33">
              2025年7月19-20日，江苏慧安智远智能医疗科技有限公司将携最新研发的“麻精药品智能管理系统”亮相2025年湖州嘉兴两市麻醉学学术年会暨临床麻醉质控年会。
            </span>
          </div>
        </div>
        <div class="text-group_13 flex-col justify-between">
          <span class="text_34">8.01</span>
          <span class="text_35">2025</span>
        </div>
      </div>
      <div class="box_4 flex-row">
        <div class="image-wrapper_4 flex-col">
          <img class="image_7" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng5338ef291cb468f37b795eafac0f7008a824c11cd9b7fbd4771b937e775fa46f.png" />
        </div>
        <img class="image_8" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5338ef291cb468f37b795eafac0f7008a824c11cd9b7fbd4771b937e775fa46f.png" />
        <div class="image-wrapper_5 flex-col">
          <img class="image_9" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng5338ef291cb468f37b795eafac0f7008a824c11cd9b7fbd4771b937e775fa46f.png" />
        </div>
      </div>
      <div class="box_5 flex-row">
        <div class="block_8 flex-col"></div>
        <div class="text-group_14 flex-col justify-between">
          <span class="text_36">7.19</span>
          <span class="text_37">2025</span>
        </div>
        <div class="block_9 flex-col"></div>
      </div>
      <div class="list_2 flex-row">
        <div class="image-text_11 flex-col justify-end" v-for="(item, index) in loopData1" :key="index">
          <!-- <div class="block_8 flex-col" :style="{ background: item.lanhuBg1 }"></div> -->
          <img class="block_8" referrerpolicy="no-referrer" :src="item.lanhuBg1" />
          <div class="text-group_15 flex-col justify-between">
            <span class="text_38" v-html="item.lanhutext0"></span>
            <span class="text_39" v-html="item.lanhutext1"></span>
          </div>
        </div>
      </div>
      <img class="image_10" referrerpolicy="no-referrer"
        src="./assets/img/SketchPng43b69aba811c2f18360eeeb4fd24aef15b140f20545644d189a231a0e6818e34.png" />
    </div>
    <div class="block_10 flex-col">
      <span class="text_40">公司介绍</span>
      <div class="box_6 flex-row">
        <div class="box_7 flex-col"></div>
        <div class="box_8 flex-col">
          <div class="text-group_16 flex-col justify-between">
            <span class="text_41">关于我们</span>
            <span class="paragraph_1">
              江苏慧安智远智能医疗科技有限公司（以下简称“公司”）于2019

              年11月注册成立，注册资金6000万元，租用无锡惠山新城生命科技产业发展有限公司厂房面积1058平方米，主要从事医疗仪器设备及器械、电子设备、通讯产品、电子智能终端的研发、生产、销售；机器人、智能家居产品的加工、销售。

              公司集产、学、研为一体，以国家“互联网+物联网+医疗”发展战略为指引，致力于医疗物联网领域的研究与开发。公司与知名大学和医院联合建立了战略合作，自主研发出和尔思麻精药品及高值耗材智能管理云平台和终端，并获得多项专利，现已形成麻精药品智能管理、麻精药品移动管理和高值耗材智能管理等系列解决方案和产品。公司结合中国医院实际业务流程、药品供应管理流程，将医院药品全流程精细化管理需求与大数据管理、物联网、自动化等技术理念进行整合，助力医院全方位信息化建设和精细化管理。

              <br />
              除以上项目，公司还对过氧化氢雾化消毒机、医院物流机器人、医用电动转运车等项目进行研发。过氧化氢雾化消毒机主要用于各科室终末消毒，布朗运动将干雾扩散到各个角落实现杀菌消毒作用。医院物流机器人系统主要用于手术室…
            </span>
          </div>
          <span class="text_42">江苏慧安智远智能医疗科技有限公司</span>
          <div class="text-wrapper_14 flex-col" @click="guanyuhuian"><span class="text_43">查看详情</span></div>
        </div>
      </div>
    </div>
    <div class="block_11 flex-col">
      <div class="text-wrapper_15 flex-row">
        <span class="text_44">公司信息</span>
        <span class="text_45">二维码</span>
        <span class="text_46">商务合作</span>
      </div>
      <div class="image-wrapper_6 flex-row justify-between">
        <img class="image_11" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png" />
        <img class="image_12" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png" />
        <img class="image_13" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png" />
      </div>
      <div class="box_9 flex-row">
        <span class="paragraph_2">
          江苏慧安智远智能医疗科技有限公司
          <br />
          <br />
          地址：无锡市惠山区惠山大道1719-5号二层B区&nbsp;
          <br />
          电话：0510-83582015
          <br />
          邮箱：huianzhiyuan&#64;qq.com
          <br />
          官网：www.hilears.com&nbsp;
          <br />
        </span>
        <div class="image-text_12 flex-col justify-between">
          <div class="image-wrapper_7 flex-col">
            <img class="image_14" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6d89f0dbceb8cf2835772a0f780d8d18a85d8ad63f161fa6700239ef2ee1b0b1.png" />
          </div>
          <span class="text-group_17">
            关注公众号：HILEARS和尔思
            <br />
          </span>
        </div>
        <span class="text_47">卢先生&nbsp;&nbsp;0510-83582015</span>
      </div>
      <div class="text-wrapper_16 flex-row">
        <span class="text_48">
          Copyright&nbsp;©&nbsp;&nbsp;2025&nbsp;-&nbsp;forever&nbsp;&nbsp;江苏慧安智远智能医疗科技有限公司所有
          <a onclick="window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32020602001022')">苏公网安备
            32020602001022号&nbsp;&nbsp;</a>
          <a onclick="window.open('https://beian.miit.gov.cn')">苏ICP备20031743号-1</a>

        </span>


      </div>
    </div>
  </div>
</template>
<script>
import sy6Img from './assets/img/sy6.png'
import sy7Img from './assets/img/sy7.png'

export default {
  data() {
    return {
      // 新增下拉菜单控制变量
      showDropdown: false,
      loopData0: [
        {
          lanhutext0: '过氧化氢消毒机',
          lanhutext1:
            '过氧化氢雾化消毒机将6%过氧化氢制成气溶胶，<br/>消杀多种微生物。体积小易拎，带远程遥控，记<br/>录可U盘导出，有权威检测及安全评价报告。',
          lanhutext2: '查看详情',
          slot3: 3
        },
        {
          lanhutext0: '麻精药品车',
          lanhutext1:
            '和尔思第二代麻精药品车载药1000支，支持单<br/>支及称重管控、冷藏，移动灵活，可自定义配<br/>置，符合五专管理，便于麻醉药管理。',
          lanhutext2: '查看详情',
          slot1: 1
        },
        {
          lanhutext0: '电动转运床',
          lanhutext1:
            '医疗电动转运床一键升降，床板伸缩助转移，<br/>电动轮省体力，耐用平稳，抗菌易清洁，降感<br/>染风险，提升体验。',
          lanhutext2: '查看详情',
          slot2: 2
        }
      ],
      loopData1: [
        {
          lanhuBg1: sy7Img,
          lanhutext0: 'J9展位实况直击！第三代麻精车被围观摩',
          lanhutext1: '开展首日J9展位盛况超预期——第三代麻精药品车前围满探究目光，AI回收箱的智能提示音此起彼伏…'
        },
        {
          lanhuBg1: sy6Img,  // 使用导入的图片
          lanhutext0: '苏州市医学会组织召开第十七次麻醉学术会议',
          lanhutext1: '2025年8月1日-8月3日，苏州市医学会组织召开第十七次麻醉学术会议暨苏州市麻醉专业医疗质量控制中心学术会议。会议在苏州市国际会议酒店举行。届时，江苏慧安智远将携麻精药品智能管理系统惊艳亮相~！'
        }
      ],
      constants: {}
    };
  },
  methods: {
    // 新增下拉菜单点击处理方法
    handleCaseClick(type) {
      // 根据不同案例类型跳转到不同页面
      this.$router.push(`/${type}`);
      // 关闭下拉菜单
      this.showDropdown = false;
    },
    gzhcgxq() {
      this.$router.push('/consumables_cabinet')
    },
    aihsxq() {
      this.$router.push('/ai_recycling_bin')
    },
    sbxq(item) {
      console.log(item)
      switch (item.lanhutext0) {
        case "过氧化氢消毒机":
          this.$router.push('/hydrogenperoxide_disinfection_machine')
          break;
        case "麻精药品车":
          this.$router.push('/two_narcotic_drug_vehicle')
          break;
        case "电动转运床":
          this.$router.push('/transfer_bed')
          break;

        default:
          break;
      }
    },
    sdycxq() {
      this.$router.push('/three_narcotic_drug_vehicle')
    },
    guanyuhuian() {
      this.$router.push('/guanyuhuian')
    },
    case_presentation() {
      this.$router.push('/case_presentation')
    },
    news_information() {
      this.$router.push('/news_information')
    },
    xwdt() {
      this.$router.push('/news_information')
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style>
/* 修改下拉菜单样式 */
.dropdown-container {
  position: relative;
  display: inline-flex;
  /* 使用inline-flex保持与其他元素对齐 */
  align-items: center;
  /* 确保文本垂直居中 */
  height: 50%;
  /* 占满父容器高度 */
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  /* 从容器底部开始显示 */
  left: 0;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  min-width: 160px;
  z-index: 1000;
  margin-top: 5px;
  /* 与主菜单保持一点距离 */
  padding: 8px 0;
  animation: fadeIn 0.2s ease-in-out;
}

/* 调整菜单项样式 */
.dropdown-item {
  padding: 10px 16px;
  color: #1d1f24;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

/* 修复父容器对齐 */
.box_1 {
  align-items: center;
  /* 确保所有子元素垂直居中 */
  display: flex;
}

/* 保持其他样式不变 */
.text_4 {
  /* 确保文本本身垂直居中 */
  display: inline-flex;
  align-items: center;
  height: 100%;
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
